const DeclarationStatusEnum = Object.freeze({
    COMPLETE: 'COMPLETE',
    NOT_COMPLETE: 'NOT_COMPLETE'
});

export default DeclarationStatusEnum;
